import { retryAxiosRequest } from '@features/_common/retryAxiosRequest'

let log = (verb, url) => {
    return url
}
let get = (url, timeout = 30000) =>
    Api.http().get(log('GET',  url), { timeout: timeout })
let post = (url, payload) => Api.http().post(log('POST', url), payload)

let prefix = ''
export class Api {
    static setPrefixToPlus() {
        prefix = '/plus'
        console.error('Setting prefix to:', prefix)
    }
    static setPrefixToPlusAdmin() {
        prefix = '/plus/verwaltung'
        console.error('Setting prefix to:', prefix)
    }

    static http() {
        return window.$_http
    }

    static postDestroyAccount() {
        return post(prefix + '/users/destroy')
    }
    static postLogout() {
        return post(prefix + '/logout')
    }
    static postResetStats(professionID) {
        return post(prefix + '/stats/reset', { professionID })
    }
    static postToAnswerStats(questionsStats) {
        const url = prefix + '/stats/questions'
        return retryAxiosRequest(() => post(url, questionsStats))
    }
    static postTestResultToBackend(resultData) {
        return post(prefix + '/tests/results', { testResults: resultData })
    }
    static postDeleteTestResults(ids) {
        return post(prefix + '/tests/results/delete', { ids })
    }
    static postUpdatedUserData(details) {
        return post(prefix + '/users/update', details)
    }
    static postChangedPassword(details) {
        return post(prefix + '/users/password/update', details)
    }
    static postMarkQuestionWith(mark, questionID, data) {
        let url = prefix + (mark ? '/bookmarks/mark' : '/bookmarks/unmark')
        return post(
            `${url}/${data.profession_id}/${data.maincategory_id}/${data.subcategory_id}/${questionID}`
        )
    }
    static postAnswer(answer) {
        return post(prefix + '/tests/answer', answer)
    }

    /**
     * 
     *  Api.postLogApi({ 
     *           'line': 307,
     *           'hint': 'DynamicContent start of calc',
     *       })} data 
     */
    static postLogApi(data) {
        return post(prefix + '/log-api', { data: data })
    }

    static getCurrentUser() {
        return get(prefix + '/users/current')
    }
    static getCurrentPlusUser() {
        return get('/plus/users/current')
    }
    static getSessionState() {
        return get(prefix + '/session/state')
    }
    static getSubscriptions() {
        return get(prefix + '/subscriptions')
    }
    static getBookmarksCountFor(professionID) {
        return get(prefix + `/bookmarks/count/${professionID}`)
    }
    static getBookmarksFor(professionID) {
        return get(prefix + `/bookmarks/${professionID}`)
    }
    static getAnswerStatsFor(professionID) {
        return get(prefix + `/stats/questions/${professionID}`)
    }
    static getAnswerStatsForUser(userID, professionID)  {
        return get(prefix+`/stats/questions/${userID}/${professionID}`)
    }
    static getProfessionStatsFor(professionID) {
        return get(prefix + `/stats/profession/${professionID}`)
    }
    static getDashboardData() {
        return get(prefix + '/dashboarddata')
    }
    static getUserData(userID) {
        return get(prefix + `/stats/userdata/${userID}`)
    }
    static getProfessionData(professionID) {
        return get(prefix + `/stats/professiondata/${professionID}`)
    }
    static getTestResultSummaries(professionID) {
        return get(prefix + `/tests/results/summary/${professionID}`)
    }
    static getTestRevisionDataFor(testResultID) {
        return get(prefix + `/tests/results/revision/${testResultID}`)
    }
    static getTestResultsFor(testResultID) {
        return get(prefix + `/tests/results/${testResultID}`)
    }
    static getTestDurationsFor(professionID) {
        return get(prefix + `/templates/durations/${professionID}`)
    }
    static postRecorderUpload(formData) {
        return post(prefix + '/recorder/upload', formData)
    }
    static getDemoData() {
        return get(prefix + '/demodata')
    }

    static getTestFor(professionID, durationType = 'kurz') {
        return get(
            prefix + `/templates/questions/${professionID}/${durationType}`
        )
    }

    static getSubCategoriesFor(professionID, mainCategoryID) {
        return get(prefix + `/subcategories/${professionID}/${mainCategoryID}`)
    }

    /**
     * fetches all questions from backend for
     * @param number professionID
     * @param number mainCategoryID
     * @param number subCategoryID
     * @returns promise for data: array of questions
     *
     * this is called in exercise-mode when a subcat is picked
     */
    static getQuestionsFor(professionID, mainCategoryID, subCategoryID) {
        return get(
            prefix +
                `/questions/${professionID}/${mainCategoryID}/${subCategoryID}`
        )
    }

    static getAllMainCategoriesStatsFor(professionID, addSubCategories = false) {
        return get(prefix+`/stats/questions/${professionID}/` + (addSubCategories ? '1' : '0'))
    }

    static getUserSettings() {
        return get(prefix + `/usersettings`)
    }
    
    static getMarketingTexts() {
        return get(prefix + `/marketing-texts`)
    }

    static setUserSetting(key, value) {
        return post(prefix + `/usersettings`, {key, value})
    }

    static addShopToken() {
        return get(prefix + `/users/add-shop-token`)
    }

    static extApiResults(results) {
        return post(prefix + `/ext-api-results`, results)
    }

    static postAudioFilename(text) {
        return post(prefix + '/text2speech/', {text})
    }

    static getGeneratedTestsFor(professionID) {
        return get(prefix + `/generated-tests/${professionID}`)
    }

    static getGeneratedTestData(testID) {
        return get(prefix + `/generated-tests/test/${testID}`)
    }

}
